import type { CheckoutProps } from '@iheartjane/data-access';

interface BuildKioskCheckoutPropsArgs {
  birthDate?: string;
  cartUuid: string;
  deviceId?: string;
  janePay: { accountVerified: boolean; bankAccountId: string } | null;
  jwt?: string | null;
  message?: string;
  name: string;
  nowSeconds: string;
  phone: string;
  userConsent?: CheckoutProps['userConsent'];
}

export const buildKioskCheckoutProps = ({
  cartUuid,
  name,
  phone,
  birthDate,
  message,
  deviceId,
  nowSeconds,
  janePay,
  jwt,
  userConsent,
}: BuildKioskCheckoutPropsArgs): CheckoutProps => ({
  cartUuid,
  appMode: 'kiosk',
  reservationMode: 'kiosk',
  customer: { name, phone },
  deliveryStartedAt: nowSeconds,
  deliveryFinishedAt: nowSeconds,
  jwt,
  ...(birthDate && { ageVerification: { birth_date: birthDate } }),
  ...(message && { message }),
  ...(deviceId && { deviceId }),
  ...(userConsent && userConsent.length > 0 && { userConsent }),
  ...(janePay && {
    paymentMethod: 'jane_pay',
    aeropayAccountVerified: janePay.accountVerified,
    aeropayBankAccountId: janePay.bankAccountId,
  }),
});
